import styled from 'styled-components';
import { Text } from '@usealloy/component-library';

export const StyledAuthContainerView = styled.div`
  background-color: white;
  color: white;
  height: 100%;

  button {
    text-transform: none;
  }

  > div {
    height: 100%;
  }

  a {
    text-decoration: underline;
    margin: 0;
    text-transform: capitalize;
    text-align: center;
  }
`;

export const StyledAlloyLogoBox = styled.div`
  position: absolute;
  top: 32px;
  left: 32px;
  cursor: pointer;
`;

export const StyledSupportButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  top: 32px;
  right: 32px;
  border: none;
  outline: none;
  background: none;
  font-weight: var(--cl-font-weight-regular);
  font-size: var(--cl-font-size-3);

  > span {
    margin-left: 8px;
  }
`;

export const StyledBackButton = styled.button`
  width: max-content;
  border: none;
  outline: none;
  background: none;

  > span {
    margin-left: 8px;
  }
`;

export const StyledAuthFooter = styled.footer`
  position: fixed;
  bottom: 32px;
  font-weight: var(--cl-font-weight-medium);
  font-size: var(--cl-font-size-1);
  color: var(--cl-text-default);
`;

export const StyledLink = styled(Text)`
  color: var(--cl-text-default);
  margin: 0;
  text-decoration: underline;
  text-transform: capitalize;
  text-align: center;
`;

export default {
  StyledAuthFooter,
};
